import { isAfter, isBefore, isSameDay } from 'date-fns'
import { ECD_ALIGN_DYNAMIC } from '../../../../utils/constants/feature-flag.constants'

export const CalculateECDAlignmentCheckBehavior = (
  isOrderlineEcd: boolean,
  orderLineEcd: Date | null | undefined,
  flexProjectEcd: Date | null | undefined
): boolean => {
  if (ECD_ALIGN_DYNAMIC) {
    if (!isOrderlineEcd && !!flexProjectEcd && orderLineEcd === null) return false
    if (isOrderlineEcd && !!orderLineEcd && flexProjectEcd === null) return false
  }

  if (isOrderlineEcd && flexProjectEcd === null) return true

  if (!isOrderlineEcd && orderLineEcd === null) return true

  if (orderLineEcd && flexProjectEcd) {
    orderLineEcd.setHours(0, 0, 0, 0)
    flexProjectEcd.setHours(0, 0, 0, 0)

    if (isSameDay(orderLineEcd, flexProjectEcd)) return true

    if (isBefore(orderLineEcd, flexProjectEcd)) return false

    if (isAfter(orderLineEcd, flexProjectEcd)) return true
  }

  return false
}

export const CalculateECDAlignmentCheckBehaviorSingle = (
  isOrderlineEcd: boolean,
  currentECD: Date | null | undefined,
  orderLineEcd: Date | null | undefined,
  flexProjectEcd: Date | null | undefined
): boolean => {
  if (ECD_ALIGN_DYNAMIC) {
    if (!isOrderlineEcd && !!flexProjectEcd && orderLineEcd === null) return false
    if (isOrderlineEcd && !!orderLineEcd && flexProjectEcd === null) return false
  }

  if (isOrderlineEcd && !currentECD && !flexProjectEcd) return true

  if (!isOrderlineEcd && !currentECD && !orderLineEcd) return true

  if ((!orderLineEcd && flexProjectEcd) || (!flexProjectEcd && orderLineEcd)) return false

  if (orderLineEcd && flexProjectEcd) {
    orderLineEcd.setHours(0, 0, 0, 0)
    flexProjectEcd.setHours(0, 0, 0, 0)

    if (isSameDay(orderLineEcd, flexProjectEcd)) return true

    if (isBefore(orderLineEcd, flexProjectEcd)) return false

    if (isAfter(orderLineEcd, flexProjectEcd)) return true
  }

  return false
}
